import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { Moment } from 'moment';
import { LoadMasterComponent } from 'src/app/Components/site/site-master/load-master/load-master.component';
import {
  ReportGroupModel,
  SiteModel,
  SiteStepperModel,
  WaterReportGroupModel
} from 'src/app/models/index';
import {
  CommonService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import { AlertService, SiteStepperEnum } from 'src/app/shared';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM'
  },
  display: {
    dateInput: 'YYYY-MM',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-report-group',
  templateUrl: './report-group.component.html',
  styleUrls: ['./report-group.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ReportGroupComponent implements OnInit {
  formData: UntypedFormGroup;
  formWaterGroup: UntypedFormGroup;
  formGasGroup: UntypedFormGroup;
  formAirGroup: UntypedFormGroup;
  stepTitle = 'Energy - Report Grouping Details';
  stepTitleForWater = 'Water - Report Grouping Details';
  stepTitleForGas = 'Gas - Report Grouping Details';
  stepTitleForAir = 'Air - Report Grouping Details';
  siteId = '';
  model: ReportGroupModel;
  energyUtility = true;
  waterUtility = true;
  gasUtility = true;
  airUtility = true;
  waterModel: WaterReportGroupModel;
  groups: any;
  waterGroups: any;
  waterLoads: any;
  gasGroups: any;
  gasLoads: any;
  airGroups: any;
  airLoads: any;
  loadDataOfSites: any;
  requiredValidators = [Validators.required, this.startWhitespace];
  siteModel: SiteModel;
  selectedGroup: any;
  waterListData: any;
  gasListData: any;
  airListData: any;
  loadDataforFG: any;
  // displayedColumns = ['groupName', 'loads'];

  //report Target form
  formConfigTarget: UntypedFormGroup;
  @ViewChild('targetpaginator') targetpaginator: MatPaginator;
  loadWise = false;
  groupWise = true;
  startDateCtr = new UntypedFormControl(moment());
  isValidStartDate = true;
  max = new Date();
  targetModel: any;
  targetGroup: any;
  targetFormTableList = [];
  targetFormDataSource: MatTableDataSource<any>;
  displayedColumnsTarget = ['kpiUtility', 'group', 'date', 'target'];
  constructor(
    private siteStepperService: SiteStepperService,
    private fb: UntypedFormBuilder,
    private cdRef: ChangeDetectorRef,
    private siteService: SiteService,
    private alertService: AlertService,
    private commonService: CommonService,
    public dialog: MatDialog
  ) {
    this.formData = this.fb.group({
      groupNameCtr: [''],
      groupCtr: [''],
      createNewGroupCtr: [],
      loadRIdCtr: ['', [Validators.required]]
    });

    this.formWaterGroup = this.fb.group({
      groupName: [''],
      groupId: [''],
      rId: [''],
      kpiName: ['Water'],
      createNewGroupCtr: [],
      loads: ['', [Validators.required]]
    });

    this.formGasGroup = this.fb.group({
      groupName: [''],
      groupId: [''],
      rId: [''],
      kpiName: ['Gas'],
      createNewGroupCtr: [],
      loads: ['', [Validators.required]]
    });

    this.formAirGroup = this.fb.group({
      groupName: [''],
      groupId: [''],
      rId: [''],
      kpiName: ['Air'],
      createNewGroupCtr: [],
      loads: ['', [Validators.required]]
    });

    //formgroup for report target config accordion
    this.formConfigTarget = this.fb.group({
      kpiUtilityCtr: ['', [Validators.required]],
      groupWiseTargetCtr: ['', [Validators.required]],
      // loadWiseTargetCtr:[],
      targetCtr: [
        '',
        [
          Validators.required,
          Validators.pattern('[0-9.]*'),
          this.checkZeroValue
        ]
      ]
    });
    this.targetModel = {};

    this.waterListData = new Array();
    this.gasListData = new Array();
    this.airListData = new Array();
  }

  public startWhitespace(control: UntypedFormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }

  ngOnInit() {
    this.model = new ReportGroupModel();
    this.siteModel = new SiteModel();
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.GroupConfiguration &&
        !this.commonService.isNullOrUndefined(data.siteModel)
      ) {
        this.siteModel = data.siteModel;
        this.siteId = this.siteModel.siteId;
        this.getAllLoads();
        //Enabling Accordion based on configured utility in site creation Form
        if (this.siteModel.configuredKpiUtilities.includes('Energy')) {
          this.energyUtility = false;
          // this.getGroupsAndLoadsOfSite();
          // this.getAllLoadsOfSiteForGroups();
          // this.getEnergyGroups();
          this.getEnergyLoads();
          this.fetchEnergyGroupUtilities();
        }
        if (this.siteModel.configuredKpiUtilities.includes('Water')) {
          this.waterUtility = false;
          this.getWaterGroups();
          this.getWaterLoads();
          this.fetchWaterGroupUtilities();
        }
        if (this.siteModel.configuredKpiUtilities.includes('Gas')) {
          this.gasUtility = false;
          this.getGasGroups();
          this.getGasLoads();
          this.fetchGasGroupUtilities();
        }
        if (this.siteModel.configuredKpiUtilities.includes('Air')) {
          this.airUtility = false;
          this.getAirGroups();
          this.getAirLoads();
          this.fetchAirGroupUtilities();
        }
      }
    });
  }

  /**
   * Validation function to check if target value is zero
   *
   * @param {UntypedFormControl} control
   * @return {*}
   * @memberof ReportGroupComponent
   */
  checkZeroValue(control: UntypedFormControl) {
    if ((control.value as number) == 0) {
      return { whitespace: true };
    }
    return null;
  }

  public goPrevious = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(
        SiteStepperEnum.ProcessAndLoadDetails,
        this.siteModel
      )
    );
  };

  public goTo = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.ReservesAndSources, this.siteModel)
    );
  };

  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formData.get(fieldName).hasError(errorCode);
  };

  /**
   * Method to prompt form field error for Water report accordion
   *
   * @param {string} fieldName
   * @param {string} errorCode
   * @memberof ReportGroupComponent
   */
  public hasError = (fieldName: string, errorCode: string): boolean => {
    return this.formWaterGroup.get(fieldName).hasError(errorCode);
  };

  /**
   * Method to prompt form field error for report target setting form accordion
   *
   * @param {string} fieldName
   * @param {string} errorCode
   * @memberof ReportGroupComponent
   */
  public isTargetFieldHasError = (
    fieldName: string,
    errorCode: string
  ): boolean => {
    return this.formConfigTarget.get(fieldName).hasError(errorCode);
  };

  public onChangeNewGroup = () => {
    switch (this.model.createNewGroup) {
      case 'false': {
        const groupNameCtr = this.formData.get('groupNameCtr');
        const groupCtr = this.formData.get('groupCtr');
        groupNameCtr.setValidators(null);
        groupCtr.setValidators(this.requiredValidators);
        groupNameCtr.updateValueAndValidity();
        groupCtr.updateValueAndValidity();
        break;
      }
      case 'true': {
        const groupNameCtr = this.formData.get('groupNameCtr');
        const groupCtr = this.formData.get('groupCtr');
        groupNameCtr.setValidators(this.requiredValidators);
        groupCtr.setValidators(null);
        groupNameCtr.updateValueAndValidity();
        groupCtr.updateValueAndValidity();
        break;
      }
      default: {
        break;
      }
    }
  };

  public submit = () => {
    const params = {
      siteId: this.siteId,
      groupRId: undefined,
      groupId: undefined,
      loadId: this.model.loadId,
      groupName: ''
    };
    if (this.model.createNewGroup === 'true') {
      params.groupName = this.model.groupname;
    } else {
      if (!this.commonService.isNullOrUndefined(this.selectedGroup)) {
        params.groupRId = this.selectedGroup.rId;
        params.groupId = this.selectedGroup.groupId;
        params.groupName = this.selectedGroup.groupName;
      }
    }

    this.siteService.saveGroupsForSite(params).subscribe((data) => {
      if (data.result === 'Success') {
        this.alertService.message = 'Saved Successfully';
        this.alertService.showSuccess(this.alertService.message);
        this.getGroupsAndLoadsOfSite();
      } else {
        this.alertService.message = data.message;
        this.alertService.showError(this.alertService.message);
      }
    });
  };

  /**
   * Method to submit water report details
   *
   * @return {*}
   * @memberof ReportGroupComponent
   */
  submitWaterDetails() {
    if (!this.formWaterGroup.valid) {
      return;
    }
    let data = this.formWaterGroup.value;
    data.loadId = data.loads.loadId;
    data.siteId = this.siteId;
    if (data.createNewGroupCtr === 'true') {
      delete data.rId;
      delete data.groupId;
    } else {
      data.groupName = data.groupId.groupName;
      data.groupId = data.groupId.groupId;
      delete data.rId;
    }
    delete data.loads;
    delete data.createNewGroupCtr;

    console.log('submitWaterdetails', data);

    this.siteService.saveUtilityGroupsForSite(data).subscribe((res) => {
      if (res && res.result == 'Success') {
        this.alertService.showSuccess(res.result);
        this.formWaterGroup.reset();
        this.fetchWaterGroupUtilities();
      } else {
        if (res.result == 'Fail') {
          this.alertService.showError(res.message);
        } else {
          this.alertService.showError(res.result);
        }
      }
    });
  }

  /**
   * Method to submit water report details
   *
   * @return {*}
   * @memberof ReportGroupComponent
   */
  submitGasDetails() {
    if (!this.formGasGroup.valid) {
      return;
    }
    let data = this.formGasGroup.value;
    data.loadId = data.loads.loadId;
    data.siteId = this.siteId;
    if (data.createNewGroupCtr === 'true') {
      delete data.rId;
      delete data.groupId;
    } else {
      data.groupName = data.groupId.groupName;
      data.groupId = data.groupId.groupId;
      delete data.rId;
    }
    delete data.loads;
    delete data.createNewGroupCtr;

    console.log('submitGasDetails', data);

    this.siteService.saveUtilityGroupsForSite(data).subscribe((res) => {
      if (res && res.result == 'Success') {
        this.alertService.showSuccess(res.result);
        this.formGasGroup.reset();
        this.fetchGasGroupUtilities();
      } else {
        if (res.result == 'Fail') {
          this.alertService.showError(res.message);
        } else {
          this.alertService.showError(res.result);
        }
      }
    });
  }

  /**
   * Method to submit water report details
   *
   * @return {*}
   * @memberof ReportGroupComponent
   */
  submitAirDetails() {
    if (!this.formAirGroup.valid) {
      return;
    }
    let data = this.formAirGroup.value;
    data.loadId = data.loads.loadId;
    data.siteId = this.siteId;
    if (data.createNewGroupCtr === 'true') {
      delete data.rId;
      delete data.groupId;
    } else {
      data.groupName = data.groupId.groupName;
      data.groupId = data.groupId.groupId;
      delete data.rId;
    }
    delete data.loads;
    delete data.createNewGroupCtr;

    console.log('submitAirDetails', data);

    this.siteService.saveUtilityGroupsForSite(data).subscribe((res) => {
      if (res && res.result == 'Success') {
        this.alertService.showSuccess(res.result);
        this.formAirGroup.reset();
        this.fetchAirGroupUtilities();
      } else {
        if (res.result == 'Fail') {
          this.alertService.showError(res.message);
        } else {
          this.alertService.showError(res.result);
        }
      }
    });
  }

  private getGroupsAndLoadsOfSite = () => {
    this.siteService
      .getGroupsAndLoadsBySiteId(this.siteId, false)
      .subscribe((groups) => {
        this.groups = groups;
      });
  };

  private getAllLoadsOfSiteForGroups = () => {
    this.siteService
      .getLoadVerticesOfSiteForGroups(this.siteId)
      .subscribe((data) => {
        this.loadDataOfSites = data;
      });
  };

  public onAddNewLoad = (event: any) => {
    event.preventDefault();
    const dialogConfig: MatDialogConfig = {
      // height: '80%',
      width: '90%'
    };
    // Open View Existing Tags Accordion
    this.dialog.open(LoadMasterComponent, dialogConfig);
  };

  /**
   * Method to get list of all loads
   *
   * @memberof ReportGroupComponent
   */
  getAllLoads() {
    this.siteService.getLoadsBySiteId(this.siteId).subscribe((data) => {
      if (data.length > 0) {
        this.loadDataforFG = data;
      }
    });
  }

  /**
   *
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private getEnergyGroups = () => {
    this.siteService
      .getUtilityLoadVerticesOfSiteForGroups(this.siteId, 'Energy')
      .subscribe((groups) => {
        this.groups = groups;
      });
  };

  /**
   *
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private getWaterGroups = () => {
    this.siteService
      .getUtilityLoadVerticesOfSiteForGroups(this.siteId, 'Water')
      .subscribe((groups) => {
        this.waterGroups = groups;
      });
  };

  /**
   *
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private getGasGroups = () => {
    this.siteService
      .getUtilityLoadVerticesOfSiteForGroups(this.siteId, 'Gas')
      .subscribe((groups) => {
        this.gasGroups = groups;
      });
  };

  /**
   *
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private getAirGroups = () => {
    this.siteService
      .getUtilityLoadVerticesOfSiteForGroups(this.siteId, 'Air')
      .subscribe((groups) => {
        this.airGroups = groups;
      });
  };

  /**
   *
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private getEnergyLoads = () => {
    this.siteService
      .getLoadsBasedOnUtility(this.siteId, 'Energy')
      .subscribe((data) => {
        this.loadDataOfSites = data;
      });
  };

  /**
   *
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private getWaterLoads = () => {
    this.siteService
      .getLoadsBasedOnUtility(this.siteId, 'Water')
      .subscribe((data) => {
        this.waterLoads = data;
      });
  };

  /**
   *
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private getGasLoads = () => {
    this.siteService
      .getLoadsBasedOnUtility(this.siteId, 'Gas')
      .subscribe((data) => {
        this.gasLoads = data;
      });
  };

  /**
   *
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private getAirLoads = () => {
    this.siteService
      .getLoadsBasedOnUtility(this.siteId, 'Air')
      .subscribe((data) => {
        this.airLoads = data;
      });
  };

  /**
   *
   *
   * @memberof ReportGroupComponent
   */
  fetchEnergyGroupUtilities() {
    let data = {
      needMeterInfo: false,
      kpiName: 'Energy',
      siteId: this.siteId
    };
    this.siteService.fetchUtilityGroupsAndLoads(data).subscribe((res) => {
      if (res) {
        this.groups = res;
      }
    });
  }

  /**
   *
   *
   * @memberof ReportGroupComponent
   */
  fetchWaterGroupUtilities() {
    let data = {
      needMeterInfo: false,
      kpiName: 'Water',
      siteId: this.siteId
    };
    this.siteService.fetchUtilityGroupsAndLoads(data).subscribe((res) => {
      if (res) {
        this.waterListData = res;
      }
    });
  }

  /**
   *
   *
   * @memberof ReportGroupComponent
   */
  fetchGasGroupUtilities() {
    let data = {
      needMeterInfo: false,
      kpiName: 'Gas',
      siteId: this.siteId
    };
    this.siteService.fetchUtilityGroupsAndLoads(data).subscribe((res) => {
      if (res) {
        this.gasListData = res;
      }
    });
  }

  /**
   *
   *
   * @memberof ReportGroupComponent
   */
  fetchAirGroupUtilities() {
    let data = {
      needMeterInfo: false,
      kpiName: 'Air',
      siteId: this.siteId
    };
    this.siteService.fetchUtilityGroupsAndLoads(data).subscribe((res) => {
      if (res) {
        this.airListData = res;
      }
    });
  }

  /**
   * Method to get groups based on utility
   *
   * @param {*} event
   * @memberof ReportGroupComponent
   */
  getGroupsBasedOnUtility(event) {
    const utility = event.value;
    if (utility == 'Energy') {
      this.targetGroup = this.groups;
    } else if (utility == 'Water') {
      this.targetGroup = this.waterListData;
    } else if (utility == 'Gas') {
      this.targetGroup = this.gasListData;
    } else if (utility == 'Air') {
      this.targetGroup = this.airListData;
    } else {
      this.targetGroup = this.groups;
    }
  }

  /**
   * Method to save Report Target Form
   *
   * @memberof ReportGroupComponent
   */
  submitTargetForm() {
    const date = this.startDateCtr.value.format('YYYY-MM');
    const params = {
      siteId: this.siteId,
      kpiUtility: this.targetModel.kpiUtility,
      group: this.targetModel.group,
      date: date,
      target: this.targetModel.target
    };
    this.siteService.addTargetDetailsForGroup(params).subscribe((data) => {
      if (data.result === 'Success') {
        this.alertService.message = 'Saved successfully!';
        this.alertService.showSuccess();
        this.formConfigTarget.reset();
        this.resetTargetForm();
        this.fetchTargetFormList();
      } else {
        this.alertService.message = 'Failed saving target, Please try again !';
        this.alertService.showError();
      }
    });
  }

  /**
   * Method to get Report Target details
   *
   * @private
   * @memberof ReportGroupComponent
   */
  private fetchTargetFormList = () => {
    this.targetFormTableList = [];
    this.siteService.getTargetDetailsForGroup(this.siteId).subscribe((data) => {
      this.targetFormTableList = data;
      this.targetFormDataSource = new MatTableDataSource<any>(
        this.targetFormTableList
      );
      this.targetFormDataSource.paginator = this.targetpaginator;
    });
  };

  /**
   * Function call to check validations for Date
   *
   * @memberof ReportGroupComponent
   */
  validateDate() {
    if (this.startDateCtr.invalid || this.startDateCtr.value == null) {
      this.isValidStartDate = false;
      this.startDateCtr.setErrors({ invalidDate: true });
      this.startDateCtr = new UntypedFormControl(moment());
    } else {
      this.isValidStartDate = true;
      this.startDateCtr.setErrors(null);
    }
  }

  /**
   * Function call on change of year in datepicker
   *
   * @param {Moment} normalizedYear
   * @memberof ReportGroupComponent
   */
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.startDateCtr.value;
    ctrlValue.year(normalizedYear.year());
    this.startDateCtr.setValue(ctrlValue);
  }

  /**
   * Function call on change of month in datepicker
   *
   * @param {Moment} normalizedMonth
   * @param {MatDatepicker<Moment>} datepicker
   * @memberof ReportGroupComponent
   */
  chosenMonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.startDateCtr.value;
    ctrlValue.month(normalizedMonth.month());
    this.startDateCtr.setValue(moment(ctrlValue).startOf('month'));
    datepicker.close();
    this.validateDate();
  }

  /**
   * Method call on click of reset button to reset report target form
   *
   * @memberof ReportGroupComponent
   */
  resetTargetForm() {
    this.targetGroup = [];
    this.targetModel = {};
  }
}
